import { Controller } from "@hotwired/stimulus";

// Reveals a "forbid to minor" warning toast on the underage Kube questionnaire
// when ANY declared trigger matches its rule. Each trigger DOM node declares
// `data-minor-content-warning-rule="<key>"`. To add a new rule, append an
// entry to RULES below — no view or controller wiring needs to change.
//
// The wrapper listens to `change` AND `input` so both checkbox toggles and
// textarea keystrokes are evaluated. Dismiss is sticky for the page visit.
const RULES = {
  romance_genre: {
    type: "checkbox",
    test: (el) => el.checked,
  },
  dark_romance_text: {
    type: "text",
    test: (el) => {
      // Strip diacritics, lowercase, then fold common leetspeak so
      // "D4rk-R0m@nce", "d@rk r0mance" etc. still trigger the warning.
      const LEET = { "4": "a", "@": "a", "0": "o", "1": "i", "3": "e", "5": "s", $: "s" };
      const normalized = (el.value || "")
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toLowerCase()
        .replace(/[4@0135$]/g, (c) => LEET[c] || c);
      return /dark[\s\-_.]*romance/.test(normalized);
    },
  },
};

export default class extends Controller {
  static targets = ["trigger", "warning"];

  connect() {
    this.dismissed = false;
    this.evaluate();
  }

  evaluate() {
    if (!this.hasWarningTarget || this.dismissed) return;
    const active = this.triggerTargets.some((el) => {
      const rule = RULES[el.dataset.minorContentWarningRule];
      return rule ? rule.test(el) : false;
    });
    this.warningTarget.hidden = !active;
  }

  dismiss(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dismissed = true;
    this.warningTarget.hidden = true;
  }
}
